import React from 'react';
import { PageHeaderPrimitives } from '@uhg-abyss/web/ui/PageHeader';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Label } from '@uhg-abyss/web/ui/Label';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { StateRouter } from '@uhg-abyss/web/ui/StateRouter';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { TopNavMenu } from '../TopNavMenu';
import { useSelector } from 'react-redux';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import {
  getCommunicationsCornerContent,
  getResourcesContent,
} from '../DropdownMenuHelpers';
import { saveAs } from 'file-saver';

const HeaderChildItemsDisplayMobile = styled('div', {
  display: 'flex', // Ensures proper alignment if needed
  justifyContent: 'flex-end',
  position: 'absolute',
  right: '0px',
  bottom: '40px',
});

export const MobileHeader = ({
  signIn,
  signOut,
  fireHeaderEvent,
  routeToPage,
  setShowSubscribeAPIModal,
  isLoggedIn,
  filteredLeftNavData,
  getPathsByTagInfo,
  subMenuTitle,
  subMenuInfo,
  isOpen,
  setIsOpen,
}) => {
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });
  const dsUserInfo = useSelector((state) => {
    return state.GET_DS_USER_INFO.data;
  });

  const HEADER_LINK_CLICK = 'header link click';

  const KbDropdownMenuContentMobile = () => {
    const pathsByTag = filteredLeftNavData();

    return (
      <React.Fragment>
        {' '}
        {getPathsByTagInfo(pathsByTag, 'mobile')}
        {}
      </React.Fragment>
    );
  };

  const getKnowledgebaseDropdown = () => {
    return (
      <StateRouter.Route path="/home/API Library" title="API Library">
        <Heading
          css={{ fontSize: '18px !important', padding: '0px $md' }}
          offset={4}
          fontWeight="$bold"
          id="utility-plans-title"
        >
          API Library
        </Heading>
        <KbDropdownMenuContentMobile />
      </StateRouter.Route>
    );
  };

  const getKnowledgebaseSubMenu = (fireHeaderEvent, menuTitle, subMenu) => {
    const { paths } = subMenu || {};

    return (
      <React.Fragment>
        <Heading
          css={{ fontSize: '18px !important', padding: '0px $md' }}
          offset={4}
          fontWeight="$bold"
          id="utility-items-title"
          title={menuTitle}
        >
          {menuTitle}
        </Heading>
        <Layout.Stack
          grow
          as="ul"
          aria-labelledby="utility-items-title"
          css={{
            '&[li]': {
              listStyle: 'none',
              margin: 0,
              padding: 0,
            },
          }}
        >
          {paths?.map((path, index) => {
            const includesDownload = path.id.includes('download');
            return (
              <li>
                <NavMenuPrimitives.MenuItem
                  key={path.id}
                  css={{
                    fontWeight: 'bold',
                    fontSize: '15px',
                    color: '#196ECF',
                    textTransform: 'capitalize',
                  }}
                  onClick={() => {
                    if (includesDownload) {
                      saveAs(path.path);
                    } else {
                      fireHeaderEvent(path.name, 'knowledge base');
                      routeToPage({
                        url: path.path,
                      });
                    }
                  }}
                  title={path.name}
                />
              </li>
            );
          })}
        </Layout.Stack>
      </React.Fragment>
    );
  };

  const getMenuItemsMobile = () => {
    const bottomMenuHeaderItems = [
      {
        title: 'Home',
        href: '/',
        header: 'notSignedIn',
        onClick: () => {
          routeToPage({
            url: '/',
          });
          fireHeaderEvent('Home', 'header', HEADER_LINK_CLICK);
        },
      },
      {
        title: 'Getting Started',
        href: '/getting-started',
        header: 'notSignedIn',
        onClick: () => {
          routeToPage({
            url: '/getting-started',
          });
          fireHeaderEvent('Getting Started', 'header', HEADER_LINK_CLICK);
        },
      },
      {
        title: 'Dashboard',
        href: '/welcome',
        header: 'signedIn',
        onClick: () => {
          routeToPage({
            url: '/welcome',
          });
          fireHeaderEvent('Dashboard', 'header', HEADER_LINK_CLICK);
        },
      },
      {
        title: 'API Library',
        header: 'both',
        content: () => {
          return getKnowledgebaseDropdown('mobile');
        },
      },
      {
        title: 'Resources',
        header: 'signedIn',
        content: () => {
          return getResourcesContent(
            fireHeaderEvent,
            routeToPage,
            dsUserInfo,
            'mobile'
          );
        },
      },
    ];
    const allCommunication = {
      title: 'Communications Corner',
      header: 'signedIn',
      content: () => {
        return getCommunicationsCornerContent(
          fireHeaderEvent,
          routeToPage,
          setShowSubscribeAPIModal,
          dsUserInfo,
          'mobile'
        );
      },
    };

    const bottomMenuItemsList = [...bottomMenuHeaderItems, allCommunication];
    const headerMenuItems = (isUserAuthorized) => {
      return bottomMenuItemsList?.filter((el) => {
        return el.header === isUserAuthorized || el.header === 'both';
      });
    };

    const unAuthorizedUserHeaderMenu = headerMenuItems('notSignedIn');
    const autorizedUserHeaderMenu = headerMenuItems('signedIn');

    const bottomMenuItems = isLoggedIn
      ? autorizedUserHeaderMenu
      : unAuthorizedUserHeaderMenu;

    const renderLink = (item) => {
      return (
        <li>
          <PageHeaderPrimitives.DrawerLink
            key={item.title}
            title={item.title}
            onClick={item.onClick}
          />
        </li>
      );
    };

    const renderDropdown = (item) => {
      return (
        <li>
          <PageHeaderPrimitives.DrawerLink
            title={item.title}
            path={`/home/${item.title}`}
          />
        </li>
      );
    };

    const homeMenu = (
      <ul>
        {bottomMenuItems.map((item) => {
          return item.content ? renderDropdown(item) : renderLink(item);
        })}
      </ul>
    );
    const dropDownMenus = bottomMenuItems
      .filter((item) => {
        return item.content;
      })
      .map((item, index) => {
        return item.content();
      });

    return (
      <React.Fragment>
        <StateRouter.Routes>
          <StateRouter.Route path="/home" title="Home">
            {homeMenu}
          </StateRouter.Route>
          {dropDownMenus}
          {
            <StateRouter.Route
              path="/home/API Library/submenu"
              title={subMenuTitle}
            >
              {getKnowledgebaseSubMenu(
                fireHeaderEvent,
                subMenuTitle,
                subMenuInfo
              )}
            </StateRouter.Route>
          }
        </StateRouter.Routes>
      </React.Fragment>
    );
  };

  return (
    <PageHeaderPrimitives.Container
      css={{
        'abyss-page-header-root': {
          zIndex: 150,
        },
      }}
    >
      <Layout.Group alignItems="center">
        <PageHeaderPrimitives.HamburgerMenu
          onClick={() => {
            setIsOpen(true);
          }}
          type="button"
          aria-label="Menu"
          aria-haspopup="dialog"
        >
          <IconSymbol icon="menu" color="$primary1" />{' '}
        </PageHeaderPrimitives.HamburgerMenu>

        <PageHeaderPrimitives.Brandmark
          logoTitle="API Marketplace"
          logoRedirect="#"
          css={{
            'abyss-page-header-logo-title': {
              color: '#002677',
              fontSize: '18px',
            },
            'abyss-page-header-toolbars': {
              minWidth: '500px',
            },
            'abyss-nav-menu-menu-trigger': {
              fontSize: '15px',
              fontWeight: 600,
            },
            '.abyss-nav-menu-viewport-container': {
              width: '500px !important',
            },
          }}
        />
        {dsUserInfo?.status && dsUserInfo?.status === 'ACTIVE' && (
          <HeaderChildItemsDisplayMobile>
            <Label color="$gray8">My Organization:&nbsp;</Label>
            <Badge variant="info">{dsUserInfo?.orgName}</Badge>
          </HeaderChildItemsDisplayMobile>
        )}
      </Layout.Group>
      <StateRouter.Provider initialPath="/home">
        <Drawer
          scrollableFocus
          isOpen={isOpen}
          onClose={() => {
            return setIsOpen(false);
          }}
          title="Menu"
          position="left"
          css={{
            '.abyss-h5-desktop': {
              fontSize: '10px',
              fontWeight: 700,
              color: '#002677',
            },
          }}
        >
          <div>
            <TopNavMenu
              userInfo={userInfo}
              signOut={signOut}
              signIn={signIn}
              fireHeaderEvent={fireHeaderEvent}
              routeToPage={routeToPage}
              isMobile
            />
          </div>
          <Divider />
          <NavMenuPrimitives.RouterHeader />
          {getMenuItemsMobile()}
        </Drawer>
      </StateRouter.Provider>
    </PageHeaderPrimitives.Container>
  );
};

MobileHeader.propTypes = {
  signIn: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  fireHeaderEvent: PropTypes.func.isRequired,
  routeToPage: PropTypes.func.isRequired,
  setShowSubscribeAPIModal: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  filteredLeftNavData: PropTypes.func.isRequired,
  getPathsByTagInfo: PropTypes.func.isRequired,
  subMenuTitle: PropTypes.string.isRequired,
  subMenuInfo: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};
